import axios from 'axios'
import { checkCandidateAccess } from '../../utils/utils'

/**
 * API for making token active for a particular session
 * @returns Empty Response
 */
export const tokenActive = async () => {
  const response = await axios.get(
    checkCandidateAccess() ? 'candidates/heartbeat' : 'auth/heartbeat'
  )
  return response
}

/**
 *
 * @param {string} challengeTypeId
 * @returns Get all Testcase Types
 */
export const getTestcaseTypes = async (challengeTypeId, subType) => {
  const query = {
    challengeTypeId,
    ...(subType ? { challengeSubType: subType } : {})
  }
  const queryString = new URLSearchParams(query).toString()
  const response = await axios.get(
    `testcases/types${queryString ? `?${queryString}` : ''}`
  )
  return response
}

/**
 *
 * @returns return user ip address
 */
export const getClientIp = async () => {
  const response = await axios.get(`ip-location`)
  return response
}

/**
 *
 * @returns
 */
export const generateApiKeyCall = async () => {
  const response = await axios.post(`keys/generate`)
  return response
}

/**
 *
 * @returns
 */
export const getApiKey = async () => {
  const response = await axios.get(`keys`)
  return response
}

export const getAttemptRemark = async (attemptId) => {
  const response = await axios.get(`attempt-remarks/${attemptId}`)
  return response
}

export const addAttemptRemark = async (payload) => {
  const response = await axios.post('attempt-remarks', payload)
  return response
}

export const updateAttemptRemark = async (remarkId, payload) => {
  const response = await axios.put(`attempt-remarks/${remarkId}`, payload)
  return response
}

export const getPasswordlessToken = async (contestUri, token) => {
  const response = await axios.post(
    `candidates/password-less-login?loginToken=${token}&contestUri=${contestUri}`
  )
  return response
}

export const getCreditDetails = async () => {
  const response = await axios.get('cache/stage-credits')
  return response
}

export const getFeatureCredits = async () => {
  const response = await axios.get('cache/feature-credits')
  return response
}

export const verifyCaptcha = async (token) => {
  const response = await axios.post('captcha/verify', { token })
  return response
}
